module.exports = __webpack_public_path__ + "static/media/register.31eca95b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/register.svg
// module id = 517
// module chunks = 0